import axios from 'axios';
import { Sentry } from '../utils/sentry';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const api = axios.create({
  baseURL: API_URL,
});

// Request interceptor — attach access token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor — handle 401 (token refresh) and 402 (subscription)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // 401: Try refresh token once
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const resp = await axios.post(`${API_URL}/auth/refresh`, {
            refresh_token: refreshToken,
          });
          const { access_token, refresh_token: newRefresh } = resp.data;
          localStorage.setItem('token', access_token);
          localStorage.setItem('refresh_token', newRefresh);
          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          return api(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem('token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      }
    }

    // 402: Subscription/quota issue — dispatch custom event for global handler
    if (error.response?.status === 402) {
      const detail = error.response.data?.detail || error.response.data;
      const event = new CustomEvent('subscription-blocked', {
        detail: {
          reason_code: detail?.reason_code || 'unknown',
          message: detail?.detail || 'Prenumerationen saknas eller har gått ut.',
        },
      });
      window.dispatchEvent(event);
    }

    // 5xx: report to Sentry with request context
    if (error.response?.status >= 500) {
      Sentry.captureException?.(error, {
        extra: {
          url: error.config?.url,
          method: error.config?.method,
          status: error.response.status,
        },
      });
    }

    return Promise.reject(error);
  }
);

export default api;
